import { render, staticRenderFns } from "./CustomerCorporateSubscription.vue?vue&type=template&id=4ed8acc5&scoped=true"
import script from "./CustomerCorporateSubscription.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateSubscription.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateSubscription.vue?vue&type=style&index=0&id=4ed8acc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8acc5",
  null
  
)

export default component.exports